<script>
import { BContainer } from "bootstrap-vue";

export default {
  extends: BContainer
};
</script>